import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './styles.css';
import '../components/NewsGrid.css';

const MANGA_LINKS = [
  { id: 1, url: 'https://asmrchurch.fanbox.cc/posts/12445629' },
  { id: 2, url: 'https://asmrchurch.fanbox.cc/posts/12445695' },
  { id: 3, url: 'https://asmrchurch.fanbox.cc/posts/12445705' },
  { id: 4, url: 'https://asmrchurch.fanbox.cc/posts/12445721' },
  { id: 5, url: 'http://asmrchurch.fanbox.cc/posts/12445740' },
];

function MangaList() {
  return (
    <div>
      <Header
        title="漫画 - ASMRキリスト教会"
        description="漫画の一覧ページです。"
        url="https://www.asmrchurch.com/manga"
        image="https://www.asmrchurch.com/static/images/i4.jpg"
      />
      <div className="news-container">
        <div className="news-header-container">
          <h1 className="news-title">漫画</h1>
        </div>
        <div style={{ color: 'var(--text)' }}>
          {MANGA_LINKS.map((item) => (
            <p key={item.id} style={{ margin: '0 0 0.75em' }}>
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                第{item.id}話
              </a>
            </p>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MangaList;
